// import { thousand } from '../../utils/format';
export const FAILED = 'SettingHarga/failed';
export const LOADING = 'SettingHarga/loading';
export const SUCCESS = 'SettingHarga/success';
export const SET_DATA = 'ListProduct/set_data';
export const CLEAR_MESSAGE = 'SettingHarga/clear_message';
export const RESET = 'SettingHarga/reset';

export const validate = (values, productGeneralMaxPrice, productGeneralMinPrice) => {
  const errors = {};
  if (values.hargaJualMin < productGeneralMinPrice) {
    errors.hargaJualMin = 'Harga jual mininum tidak sesuai dengan ketentuan. Apabila diperlukan penyesuaian silakan hubungi admin';
    // `Harga jual minimum tidak boleh kurang dari Rp ${thousand(productGeneralMinPrice)}`;
  }
  if (values.hargaJualMax > productGeneralMaxPrice) {
    errors.hargaJualMax = 'Harga jual maksimum tidak sesuai dengan ketentuan. Apabila diperlukan penyesuaian silakan hubungi admin';
    // `Harga Jual Maksimum tidak boleh lebih dari Rp ${thousand(productGeneralMaxPrice)}`;
  }
  if (!values.hargaJualMin) {
    errors.hargaJualMin = { _error: 'Harga Jual Minimum harus diisi' };
  }
  if (!values.hargaJualMax) {
    errors.hargaJualMax = { _error: 'Harga Jual Maksimum harus diisi' };
  }

  if (parseFloat(values.hargaJualMin) <= 0) {
    errors.hargaJualMin = 'Harga Jual Minimum harus diatas 0';
  }

  if (parseFloat(values.hargaJualMax) <= 0) {
    errors.hargaJualMax = 'Harga Jual Maksimum harus diatas 0';
  }

  if (values.hargaJualMin.toString().length > 6) {
    errors.hargaJualMin = 'Harga Jual Minimum tidak boleh lebih dari 6 digit';
  }
  if (values.hargaJualMax.toString().length > 6) {
    errors.hargaJualMax = 'Harga Jual Maksimum tidak boleh lebih dari 6 digit';
  }

  if (parseFloat(values.hargaJualMin) > parseFloat(values.hargaJualMax)) {
    errors.hargaJualMin = 'harus lebih kecil dari harga maksimum';
    errors.hargaJualMax = 'harus lebih besar dari harga minimum';
  }
  return errors;
};
